import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import ApplicationLoading from '../../../common/ApplicationLoading';
import { agentHubPaths } from '../../../util/constants';
import { PROVISIONING_PATH_BY_PLATFORM } from './paths';
import { useProvisioningPlatform } from './useProvisioningPlatform';

/** Redirects `/provisioning` to the merchant's own platform checklist. */
export const ProvisioningIndexRedirect = (): JSX.Element => {
  const { search } = useLocation();
  const { platform, isLoading } = useProvisioningPlatform();

  if (isLoading) {
    return <ApplicationLoading />;
  }

  const target = platform ? PROVISIONING_PATH_BY_PLATFORM[platform] : agentHubPaths.DASHBOARD;
  // Keeps ?merchantId for admins viewing another merchant.
  return <Navigate to={`${target}${search}`} replace />;
};
